import axios from 'axios';
import './App.css'
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useState } from 'react';

function PageSignupWithGoogle() {
    const [step, setStep] = useState('confirm');
    const [didAcceptTC, setDidAcceptTC] = useState(false);

    function createAccount() {
        setStep('creating_account');
        axios.post(
            process.env.REACT_APP_API_HOST + '/signup/google/',
            {
                token: localStorage.getItem('token')
            }
        ).then(
            (response) => {
                setTimeout(
                    () => {
                        localStorage.setItem('user_id', response.data.user_id);
                        window.location = '/feed/';
                    },
                    1000,
                );
            }
        ).catch(
            (error) => {
            }
        )

    }

    if (step == 'creating_account') {
        return (
            <div
                align='center'
                style={{
                    margin: '0',
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
            >
                <div
                    className='standard-box'
                    style={{ padding: '4em' }}
                >
                    <ProgressSpinner />
                    <h2>
                        Creating your account...
                    </h2>
                    <h4>
                        May take few moments.
                    </h4>
                </div>
            </div>
        );
    }

    return (
        <div
            style={{
                margin: '0',
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}
        >
            <div className='standard-box' align='left'>
                <h1>
                    Sign up with Google
                </h1>
                <div align='left' style={{ marginTop: '2em' }}>
                    <h3>
                        Terms and Conditions:
                    </h3>
                    <ul>
                        <li>
                            this is a Beta product and occasionally things may break
                        </li>
                        <li>
                            the given version is free of charge
                        </li>
                        <li>
                            there is no responsability at all about anything
                        </li>
                        <li>
                            by signing up, you agree with the standard GDPR
                        </li>
                    </ul>
                    <p>
                    </p>
                </div>
                <div
                    className="flex align-items-center"
                    style={{ marginTop: '0.5em' }}
                    align='left'
                >
                    <Checkbox
                        inputId="accept_tc_label"
                        name="tc_label"
                        value="Agree with T&Cs to continue."
                        onChange={() => {
                            setDidAcceptTC(!didAcceptTC);
                        }}
                        checked={didAcceptTC}
                    />
                    <label
                        htmlFor="accept_tc_label" className="ml-2"
                        style={{ marginLeft: '0.5em' }}
                    >
                        agree with T&Cs to continue
                    </label>
                </div>
                <div style={{ margin: '2em' }}>
                    <Button
                        label="Back"
                        severity="secondary"
                        onClick={
                            () => {
                                window.location = '/';
                            }
                        }
                        style={{ width: '40%', margin: '0.5em' }}
                    />
                    <Button
                        label="Continue"
                        severity="success"
                        disabled={!didAcceptTC}
                        raised
                        style={{ width: '40%', margin: '0.5em' }}
                        onClick={createAccount}
                    />
                </div>
            </div>
        </div>
    );
}

export default PageSignupWithGoogle;